import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { z } from 'zod';

import { queryClient } from '../QueryApiProvider';

const schema = z.object({
  url: z.string().url(),
});

type ResponseSchemaType = z.infer<typeof schema>;

async function fetchAvatar(address: string): Promise<ResponseSchemaType> {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const data = await fetch(
    new URL(
      `/profile-image/${address}`,
      import.meta.env.VITE_TALKJS_URL,
    ).toString(),
  ).then((res) => res.json());

  return schema.parse(data);
}

export function useAvatarQuery(
  address: string,
): UseQueryResult<ResponseSchemaType> {
  const initialData = {
    url: `https://api.dicebear.com/7.x/identicon/svg?seed=${address}&backgroundColor=000000`,
  };
  return useQuery({
    queryKey: ['avatar', address],
    queryFn: () => fetchAvatar(address),
    onError: () => {
      queryClient.setQueryData(['avatar', address], initialData);
    },
    retry: 0,
    enabled: Boolean(address),
    staleTime: 5 * 60 * 1000,
  });
}
